/**
 * Sprint Management Page
 * Thin route wrapper around SprintManagementView — resolves boardId/sprintId from the URL
 * and hands off to the shared view. See SprintManagementView.tsx for the actual UI/logic;
 * SprintBoard.tsx's inline "Sprints" tab renders the same view directly (no route).
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import SprintManagementView from './SprintManagementView';

const SprintManagement: React.FC = () => {
  const { boardId, sprintId } = useParams<{ boardId: string; sprintId?: string }>();

  // Use default board ID for testing if not provided
  const effectiveBoardId = boardId || 'board-1';

  return <SprintManagementView boardId={effectiveBoardId} sprintId={sprintId} />;
};

export default SprintManagement;
